import script from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./NuovaRilevazione.vue?vue&type=style&index=0&id=721726c8&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721726c8"]])

export default __exports__